<template>
  <div class="card" :class="{ loaded: loaded }" @click="loaded = !loaded">
    <div class="container">
      <div class="box" :class="state">
        <div class="badge_bg"></div>
      </div>

      <div class="badge">
        <Transition name="fade" mode="out-in">
          <div v-if="loaded == false" class="loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div v-else class="logo">
            <img src="./assets/logo.png" style="width: 40px; height: 40px" />
          </div>
        </Transition>
      </div>
    </div>

    <div class="text">
      <p class="title">Inlog verwerken</p>
    </div>
  </div>
</template>

<script>
const QUERY_CODE_KEY = "code";
const QUERY_STATE_KEY = "state";
const QUERY_CODE_WEBHOOK_IDENTIFIERS = [
  "@webhooked",
  "@webhook",
  "@hooked",
  "@hook",
];

export default {
  name: "App",
  data() {
    return {
      loaded: false,
      state: "pending",
    };
  },
  async mounted() {
    let url = new URL(window.location.href);

    if (url.searchParams.has(QUERY_STATE_KEY) == false) {
      this.isFailed();
    }

    let code = url.searchParams.has(QUERY_CODE_KEY)
      ? url.searchParams.get(QUERY_CODE_KEY)
      : undefined;
    let stateEncoded = url.searchParams.get(QUERY_STATE_KEY);
    let state = atob(stateEncoded);

    let decoded = new URLSearchParams(state);

    if (code == undefined || QUERY_CODE_WEBHOOK_IDENTIFIERS.includes(code)) {
      await this.handleWebhook(decoded);
    } else {
      await this.handleOAuthFlow(code, decoded);
    }
  },
  methods: {
    /**
     * @param {URLSearchParams} decoded
     */
    async handleWebhook(decoded) {
      let apiUrl = "/api/hook/end";

      let query = new URLSearchParams({
        id: decoded.get("id"),
        signature: decoded.get("signature"),
      });

      return this.handleStateCheck(apiUrl, query);
    },
    /**
     * @param {string} code
     * @param {URLSearchParams} decoded
     */
    async handleOAuthFlow(code, decoded) {
      let apiUrl = "/api/flow/end";

      let query = new URLSearchParams({
        id: decoded.get("id"),
        signature: decoded.get("signature"),
        code: code,
      });

      return this.handleStateCheck(apiUrl, query);
    },
    async handleStateCheck(apiUrl, query) {
      try {
        let res = await fetch(`${apiUrl}?${query}`, {
          method: "POST",
        });
        let data = await res.json();

        if (data.id !== query.get("id")) {
          this.isFailed();
          return;
        }

        switch (data.state) {
          case 0:
          case 1:
            this.isPending();
            return;
          case 404:
            this.isFailed();
            return;
          default:
            this.isSuccess();
            return;
        }
      } catch {
        this.isFailed();
      }
    },
    isSuccess() {
      this.state = "success";
      console.info("Authentication State: " + this.state);
      setTimeout(() => (this.loaded = true), 250);
    },
    isPending() {
      this.state = "pending";
      console.info("Authentication State: " + this.state);
      setTimeout(() => (this.loaded = true), 250);
    },
    isFailed() {
      this.state = "failed";
      console.info("Authentication State: " + this.state);
      setTimeout(() => (this.loaded = true), 250);
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.32s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
html {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin: 0;
}

body {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  min-height: 100vh;
  margin: 0;
  background-color: #aeaeaf;
  font-family: system, -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 20px;
  color: #5d6494;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.container {
  width: 220px;
  height: 220px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.box {
  position: absolute;
  width: 220px;
  height: 220px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  border-radius: 3px;
  overflow: hidden;
  -webkit-transition: -webkit-box-shadow ease 1s;
  transition: -webkit-box-shadow ease 1s;
  transition: box-shadow ease 1s;
  transition: box-shadow ease 1s, -webkit-box-shadow ease 1s;
}

.badge {
  position: relative;
  margin-top: 8px;
  -webkit-transition: all 0.6s ease;
  transition: all 0.6s ease;
  -webkit-transition-delay: 0.32s;
  transition-delay: 0.32s;
  will-change: transform;
}

.badge_bg {
  width: 80px;
  height: 80px;
  border-radius: 100%;
  border: 1px solid rgba(225, 227, 232, 0.18);
  -webkit-box-shadow: 0 3px 4px 0 rgba(44, 71, 146, 0.25);
  box-shadow: 0 3px 4px 0 rgba(44, 71, 146, 0.25);
  background-color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-transition: all 0.6s ease;
  transition: all 0.6s ease;
  -webkit-transition-delay: 0.32s;
  transition-delay: 0.32s;
  will-change: transform;
}

.title {
  position: relative;
}

.card.loaded .box {
  /*   border: 1px solid rgba(225, 227, 232, 0.18); */
  -webkit-box-shadow: 0 3px 4px 0 rgba(44, 71, 146, 0.25);
  box-shadow: 0 3px 4px 0 rgba(44, 71, 146, 0.25);
  -webkit-transition-delay: 0.32s;
  transition-delay: 0.32s;
}

.card.loaded .badge_bg {
  -webkit-transform: translateY(-32px) scale(6);
  transform: translateY(-32px) scale(6);
}

.card.loaded .badge {
  -webkit-transform: translateY(-48px) scale(1.4);
  transform: translateY(-48px) scale(1.4);
}

.card {
  width: 220px;
  height: 220px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.text {
  position: relative;
  top: -32px;
  width: 200px;
  text-align: center;
  -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease;
  -webkit-transition-delay: 0.32s;
  transition-delay: 0.32s;
}

.card.loaded .text {
  opacity: 0;
  -webkit-transform: translateY(-4px) scale(0.8);
  transform: translateY(-4px) scale(0.8);
}

.box.success::after {
  content: "U bent succesvol verbonden, u kunt deze pagina sluiten!";
  position: absolute;
  width: 170px;
  top: 111px;
  opacity: 0;
  font-size: 13px;
  color: #3d516a;
  line-height: 20px;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  -webkit-transition-delay: 0.32s;
  transition-delay: 0.32s;
}

.box.pending::after {
  content: "Nog even geduld, de verbinding wordt nog tot stand gebracht!";
  position: absolute;
  width: 170px;
  top: 111px;
  opacity: 0;
  font-size: 13px;
  color: #8d4e14;
  line-height: 20px;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  -webkit-transition-delay: 0.32s;
  transition-delay: 0.32s;
}

.box.failed::after {
  content: "Verbindig mislukt, probeert u het later opnieuw!";
  position: absolute;
  width: 170px;
  top: 111px;
  opacity: 0;
  font-size: 13px;
  color: #a24f4f;
  line-height: 20px;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  -webkit-transition-delay: 0.32s;
  transition-delay: 0.32s;
}

.card.loaded .box::after {
  opacity: 1;
}
</style>

<style>
.loader {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.loader div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #3d516a;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.loader div:nth-child(1) {
  left: 8px;
  animation: loader1 0.6s infinite;
}
.loader div:nth-child(2) {
  left: 8px;
  animation: loader2 0.6s infinite;
}
.loader div:nth-child(3) {
  left: 32px;
  animation: loader2 0.6s infinite;
}
.loader div:nth-child(4) {
  left: 56px;
  animation: loader3 0.6s infinite;
}
@keyframes loader1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes loader3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes loader2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
</style>
